import React from "react";
import { Box } from "@mui/material";
import {
  UtilityBillTypeKey,
  UtilityBillType,
  Tooltip,
} from "components";
import { TABLE_HEADERS, EMPTY_CELL_VALUE } from "consts";

export const INITIAL_STATUS_OPTIONS = [
  { key: "PBE", value: "Estimates" },
  { key: "Active", value: "Active" },
  { key: "Partially Active", value: "Partially Active" },
];

export const ALL_STATUS_OPTIONS = [
  ...INITIAL_STATUS_OPTIONS,
  { key: "Historical", value: "Historical" },
  { key: "Inactive", value: "Inactive" },
];

export const DATA_BOXES = [
  { color: "#FBCBC4", title: "No Data" },
  { color: "#D0EFFD", title: "Estimates" },
  { color: "#E4EC81", title: "Partial Data" },
  { color: "#CBF2AC", title: "Complete" },
  { color: "#DDDDDD", title: "Deactivated" },
];

export const MISSING_DOCUMENTS_PAGE = {
  ABSOLUTE_PATH: "/documents/missing",
  PATH: "missing",
  TITLE: "Missing documents",
};

export const MISSING_DOCUMENTS_PAGE_QUERY_PARAMS = {
  COLLECTOR_ID: "collectorId",
  MONTH: "month",
};

export const MISSING_DOCUMENTS_STATIC_COLUMNS = [
  {
    header: "Site",
    accessorKey: "collector.siteName",
    Cell: ({ cell }: { cell: any }) => {
      const value = (cell.getValue() as string) ?? EMPTY_CELL_VALUE;
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              padding: "0 16px",
              textOverflow: "ellipsis",
              maxWidth: "159px",
            }}
          >
            {value}
          </Box>
        </Tooltip>
      );
    },
    enableSorting: false,
    enablePinning: true,
    minSize: 160,
    size: 160,
    resizable: true,
  },
  {
    header: "Source",
    accessorKey: "collector.providerName",
    Cell: ({ cell }: { cell: any }) => {
      const value = (cell.getValue() as string) ?? EMPTY_CELL_VALUE;
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              padding: "0 16px",
              textOverflow: "ellipsis",
              maxWidth: "179px",
            }}
          >
            {value}
          </Box>
        </Tooltip>
      );
    },
    enableSorting: false,
    enablePinning: true,
    minSize: 180,
    size: 180,
    resizable: true,
  },
  {
    header: TABLE_HEADERS.accountNumber,
    accessorKey: "collector.accountNumber",
    Cell: ({ cell }: { cell: any }) => {
      const value = (cell.getValue() as string) ?? EMPTY_CELL_VALUE;
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              padding: "0 16px",
              textOverflow: "ellipsis",
              maxWidth: "138px",
            }}
          >
            {value}
          </Box>
        </Tooltip>
      );
    },
    enableSorting: false,
    enablePinning: true,
    minSize: 140,
    size: 140,
    resizable: true,
  },
  {
    header: TABLE_HEADERS.meterNumber,
    accessorKey: "collector.meterNumber",
    Cell: ({ cell }: { cell: any }) => {
      const value = (cell.getValue() as string) ?? EMPTY_CELL_VALUE;
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              padding: "0 16px",
              textOverflow: "ellipsis",
              maxWidth: "139px",
            }}
          >
            {value}
          </Box>
        </Tooltip>
      );
    },
    enableSorting: false,
    enablePinning: true,
    minSize: 140,
    size: 140,
    resizable: true,
  },
  {
    header: "Status",
    accessorKey: "status",
    Cell: ({ cell }: { cell: any }) => {
      const value = (cell.getValue() as string) ?? EMPTY_CELL_VALUE;
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              padding: "0 16px",
              textOverflow: "ellipsis",
              maxWidth: "139px",
            }}
          >
            {value === "PBE" ? "Estimates" : value}
          </Box>
        </Tooltip>
      );
    },
    enableSorting: false,
    enablePinning: true,
    minSize: 140,
    size: 140,
    resizable: true,
  },
  {
    header: "Type",
    accessorKey: "collector.utilityTypeName",
    Cell: ({ cell }: { cell: any }) => {
      const value = (cell.getValue() as UtilityBillTypeKey) ?? EMPTY_CELL_VALUE;
      return (
        <Box
          sx={{
            padding: "0 16px",
            textOverflow: "ellipsis",
            maxWidth: "139px",
          }}
        >
          <UtilityBillType type={value} />
        </Box>
      );
    },
    enableSorting: false,
    enablePinning: true,
    minSize: 140,
    size: 140,
    resizable: true,
  },
];
